import {Component, Input, Optional, Self, TemplateRef, ViewChild} from "@angular/core";
import {Utils} from "src/app/core/helpers/Utils";
import {
    ControlValueAccessor,
    NgControl
} from "@angular/forms";
import {FormControlComponent} from "@fundamental-ngx/core";

@Component({
    selector: "app-reactive-input",
    templateUrl: "./reactive-input.component.html",
    styleUrls: ["./reactive-input.component.scss"],
    standalone: false
})
export class ReactiveInputComponent implements ControlValueAccessor {
    @ViewChild('input') input: FormControlComponent;
    @Input() customErrorMessage: string;
    private innerValue = '';
    private onTouchedCallback: () => void = () => {
    };
    private onChangeCallback: (_: any) => void = () => {
    };

    get value(): any {
        return this.innerValue;
    }

    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }

    onBlur() {
        this.onTouchedCallback();
    }

    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    Utils = Utils;
    id = "id" + Math.random().toString(16).slice(2);

    @Input() label: string;
    @Input() required = true;
    @Input() popoverTitle: string;
    @Input() popoverDescription: string | TemplateRef<any>;
    @Input() popoverWidth = "25rem";
    @Input() placeholder: string;

    get isPopoverDescriptionTemplate(): boolean {
        return this.popoverDescription instanceof TemplateRef;
    }

    constructor(
        @Self()
        @Optional()
        public ngControl: NgControl
    ) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
}
